<app-tenants-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-tenants-filters>

<mat-card class="add-button-container" *ngIf="!(tenants | async)?.length">
  <h4>Nessun punto vendita trovato</h4>
  <button class="add-button" *ngIf="canAdd" mat-raised-button (click)="addTenant()" color="primary">
    Aggiungi
  </button>
</mat-card>

<div class="table-container" [hidden]="!(tenants | async).length">
  <table mat-table matSort [dataSource]="tenants" multiTemplateDataRows matSortDisableClear matSortActive="name"
    matSortDirection="asc">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef> Indirizzo </th>
      <td mat-cell *matCellDef="let element"> {{ element.address }} </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Telefono </th>
      <td mat-cell *matCellDef="let element"> {{ element.phone }} </td>
    </ng-container>

    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef> Città </th>
      <td mat-cell *matCellDef="let element"> {{ element.city }} </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="add-icon-container">
        <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo punto vendita"
          (click)="$event.stopPropagation(); addTenant()" color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row" class="modify-icon-container">
        <ng-container *ngIf="canEdit">
          <button mat-icon-button (click)="$event.stopPropagation(); editTenant(row)">
            <mat-icon matTooltip="Modifica">create</mat-icon>
          </button>
        </ng-container>

        <button *ngIf="canSelect" mat-raised-button color="primary" (click)="selectTenant(row)">
          Seleziona
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editTenant(row)"></tr>
  </table>

  <mat-paginator     [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>
</div>
